import { adminAPIService } from './index'

const route = 'trending-feeds'

export default {
  getList(params) {
    /**
     * Get trending feeds list
     * @param {object} params
      {
        page: number
        size: number
      }
    */
    return adminAPIService({
      url: route,
      method: 'get',
      params,
    })
  },
  getDetail(id) {
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'get',
    })
  },
  create(detail) {
    const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    return adminAPIService({
      url: route,
      method: 'post',
      data: body,
    })
  },
  update(detail, id) {
    const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'post',
      data: body,
    })
  },
  delete(id) {
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'delete',
    })
  },
  // batch(file) {
  //   const formData = new FormData()
  //   formData.append('file', file)
  //   return adminAPIService({
  //     url: `${route}/batch`,
  //     method: 'post',
  //     data: formData,
  //   })
  // },
}
export const uploadTrendingBatch = ({ file }) => {
  const formData = new FormData()
  formData.append('csv', file)

  return adminAPIService({
    url: `${route}/batch`,
    method: 'post',
    data: formData,
  })
}
